import { call, takeLatest } from 'redux-saga/effects';
import actionTypes from '../../actions/actionTypes';
import { getPushDataCall } from '../../apis/wpApi/apiCalls';
import getCurrentWeeksArray from '../../functions/getCurrentWeeksArray';
import { putSuccess, putError } from '../helpers'
import authUser from '../../apis/wpApi/authUser';



function* getData({payload}) {
    try {
        const apiKey = yield call(authUser.getToken)
        const response = yield call(getPushDataCall, apiKey, payload.signal)

        if(!response || !response.status || 200 !== response.status || !response.data || !response.data.pushes || !response.data.generalSettings) {
            throw new Error('Could not update data')
        } else {
            const generalSettings = yield response.data.generalSettings
            const pushes = yield response.data.pushes
         
            yield putSuccess(actionTypes.PUSH_DATA_GET_SUCCESS, {
                pushes: pushes, 
                generalSettings: generalSettings
            })
        }
    } catch(e) {
        console.log('ERROR', e)
        yield putError(actionTypes.PUSH_DATA_GET_ERROR, e.message)
    }
}


function* watchPushDataGetRequest() {
    yield takeLatest(actionTypes.PUSH_DATA_GET_REQUEST, getData);
}

export default watchPushDataGetRequest